import { StyledFieldGrid } from "pages/CreateOrder/CreateOrder.styled";
import { ReactNode } from "react";
import styled from "styled-components";

const StyledInsuranceBox = styled(StyledFieldGrid)`
  background: var(--brand-gray-50);
  border-color: var(--brand-gray-200);
`;

export function InsuranceBox({
  title,
  action,
  children,
}: {
  title: string;
  action?: ReactNode;
  children: ReactNode;
}) {
  return (
    <StyledInsuranceBox className="mx-3 p-4 border-1 border-round-2xl">
      <div className="flex align-items-center gap-3 mb-3">
        <span
          className="text-base font-bold"
          style={{ color: "var(--brand-black)" }}
        >
          {title}
        </span>
        {action ? <div className="ml-auto">{action}</div> : null}
      </div>
      {children}
    </StyledInsuranceBox>
  );
}
